// extracted by mini-css-extract-plugin
export default {"price":"O7-z","onSale":"P7-z","msrpLabelPrice":"Q7-z","msrpLabel":"R7-z","originalPrice":"S7-z","percentOff":"T7-z"};